var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dueDate)?_c('div',{staticClass:"product-item-info-bottom"},[_c('p',[_vm._v(_vm._s(((_vm.dueDate.period) + "-" + (_vm.$t(_vm.dueDate.text)) + " " + (_vm.$fc(_vm.dueDate.regularPrice)) + " (" + (_vm.dueDate.discount) + ")")))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }